import { capitalize } from 'vue';

import { Filter, FilterComparisonOperator, FilterLogicalOperator } from '@/common/models/query-params';
import i18n from '@/vueI18n';

interface IPackageBuyerOfferedToOption {
  value: string;
  name: string;
  filters: Filter[];
}

export default class PackageBuyerOfferedToOptions {
  static getLocalizedOptionName(name): string {
    return capitalize(i18n.global.t(`names.${name}`, 2));
  }

  static options(buyerIDs: number[]): IPackageBuyerOfferedToOption[] {
    return [
      {
        value: 'PUBLIC_DEALS',
        name: PackageBuyerOfferedToOptions.getLocalizedOptionName('publicDeal'),
        filters: [
          new Filter(
            'package_organization_restrictions.organization_dsp_id',
            [null],
            FilterComparisonOperator.NOT_EQUAL,
            FilterLogicalOperator.NOT,
          ),
        ],
      },
      {
        value: 'MY_DEALS',
        name: PackageBuyerOfferedToOptions.getLocalizedOptionName('myDeal'),
        filters: [
          new Filter('package_organization_restrictions.organization_dsp_id', buyerIDs, FilterComparisonOperator.IN),
        ],
      },
    ];
  }
}
